/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{-ms-flex:1 1 auto;flex:1 1 auto;display:-ms-inline-flexbox;display:inline-flex}.error[_ngcontent-%COMP%]{-ms-flex:1 1 auto;flex:1 1 auto;display:-ms-inline-flexbox;display:inline-flex;position:relative;color:#fff;background:#d2504d;border-radius:3px;padding:4px 8px;margin-top:2px;font-size:.9em}.error[_ngcontent-%COMP%]:before{content:\" \";display:block;position:absolute;top:-4px;left:8px;width:0;height:0;border-left:4px solid transparent;border-right:4px solid transparent;border-bottom:4px solid #d2504d}"];
export { styles as styles };
